import { useState, useEffect, useCallback } from "react";
function useExplanationQuiz({
  quizId,
  quiz,
  onSolve,
  solveResult,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  onAnswerChange
}) {
  const [startTime] = useState(() => Date.now());
  const [isShowingCorrectAnswers, setIsShowingCorrectAnswers] = useState(false);
  const isSolved = solveResult !== null && solveResult !== void 0;
  const computedInitialAnswer = (initialAnswersProp == null ? void 0 : initialAnswersProp[0]) ?? "";
  const [answer, setAnswer] = useState(computedInitialAnswer);
  const canSubmit = answer.trim().length > 0;
  useEffect(() => {
    onAnswerChange == null ? void 0 : onAnswerChange([answer]);
  }, [answer, onAnswerChange]);
  const handleSubmit = useCallback(() => {
    if (!canSubmit || isSolved) return;
    const elapsedTime = Date.now() - startTime;
    onSolve == null ? void 0 : onSolve(quizId, [answer], quiz.vars, elapsedTime);
  }, [answer, canSubmit, isSolved, onSolve, quizId, quiz.vars, startTime]);
  return {
    answer,
    setAnswer,
    isSolved,
    canSubmit,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    handleSubmit,
    quiz,
    quizId,
    solveResult,
    isViewSolved
  };
}
export {
  useExplanationQuiz
};
//# sourceMappingURL=use-explanation-quiz.js.map
